import Vue from "vue";
import VueCookies from "vue-cookies";
import CryptoJS from "crypto-js";
import { store } from "../store/store.js";
import axios from "axios";
import router from "../router/index";
Vue.use(VueCookies);

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
localStorage.setItem("packapp_api_url", process.env.VUE_APP_BASE_URL);
localStorage.setItem("qc_api_url", process.env.VUE_APP_QC_URL);

const appLogging = function () {
  return new Promise(async (resolve, reject) => {
    // Get from cookies
    const username = Vue.$cookies.get("username");
    const encryptedPassword = Vue.$cookies.get("password");
    if (router.path !== "/pages/login" && (!username || !encryptedPassword)) {
      // window.location.href = "#/pages/login";
      router.push("/pages/login");
    } else {
      // Decrypt
      var bytes = CryptoJS.AES.decrypt(encryptedPassword, "Marepoto-Tusunami");
      var password = bytes.toString(CryptoJS.enc.Utf8);

      const payload = {
        username: username,
        password: password
      };

      // Login using vuex

      try {
        await store.dispatch("login", payload);
        console.log("Session login success");
        resolve();
      } catch (error) {
        console.log("Session login failed");
        console.log(error);
        router.push("/pages/login");
        reject(error);
      }
    }
  });
};

export { appLogging };
